import { Box, Container } from '@mui/material'
import { useCFDContext } from 'pages/CustomerFacingDisplayPage/context/useCFDContext'
import { TopSection } from './OrderDisplay/TopSection'
import OrderInfoDisplay from './OrderDisplay/OrderInfoDisplay'
const OrderDisplayPage = () => {
    const { orderPayload } = useCFDContext()
    const isNotSingleOrder =
        (orderPayload?.multipleOrderDetails?.length ?? 0) > 1
    return (
        <Container sx={(x) => ({ background: x.palette.background.paper })}>
            <Box
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'flex-start'}
                pt={4}
                sx={(x) => {
                    return { height: '97svh' }
                }}
            >
                <Box py={2}>
                    <TopSection
                        orderName={orderPayload?.orderName}
                        customerName={orderPayload?.customerName}
                        tableName={orderPayload?.tableName}
                    />
                </Box>
                <OrderInfoDisplay
                    {...orderPayload}
                    showAssignTo={isNotSingleOrder}
                    subOrders={orderPayload?.multipleOrderDetails ?? []}
                />
            </Box>
        </Container>
    )
}

export default OrderDisplayPage
